export default __webpack_public_path__ + "static/media/home-digital-agency-bg-img-02.3e97c46f.jpg";